module.exports = __webpack_public_path__ + "img/4.6fd819fa.jpg";